import {
  DOMAIN_EDIT, DOMAIN_EDIT_FAILURE, DOMAIN_EDIT_SUCCESS, DOMAIN_UPDATE, DOMAIN_UPDATE_FAILURE, DOMAIN_UPDATE_SUCCESS
} from './mutation-types'

export default {
  state: {
    domain: null
  },
  getters: {
    domain: state => {
      return state.domain
    }
  },
  actions: {
    [DOMAIN_EDIT] ({dispatch, state, commit}, params = null) {
      var data = params.data
      var callback = null
      if (data) {
        callback = data.callback
      }
      var url = '/master/domains/' + params.id
      dispatch('apiGet', {url: url, data: {id: params.id}, loadparams: true})
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(DOMAIN_EDIT_FAILURE, res.data)
            } else {
              res.data.callback = callback
              commit(DOMAIN_EDIT_SUCCESS, res.data)
            }
          }
        })
        .catch(error => {
          throw error
        })
    },
    [DOMAIN_UPDATE] ({dispatch, state, commit}, params = null) {
      var data = params.data
      var url = '/master/domains/' + params.id
      dispatch('apiPatch', {url: url, data: data})
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(DOMAIN_UPDATE_FAILURE, res.data)
            } else {
              commit(DOMAIN_UPDATE_SUCCESS, { data: res.data, callback: params.callback })
            }
          }
        })
        .catch(error => {
          throw error
        })
    }
  },
  mutations: {
    [DOMAIN_EDIT_FAILURE] (state, data) {
      console.log('DOMAIN_EDIT_FAILURE')
    },
    [DOMAIN_EDIT_SUCCESS] (state, data) {
      console.log('DOMAIN_EDIT_SUCCESS')
      state.domain = data
      if (data.callback) {
        data.callback()
      }
    },
    [DOMAIN_UPDATE_FAILURE] (state, data) {
      console.log('DOMAIN_UPDATE_FAILURE')
    },
    [DOMAIN_UPDATE_SUCCESS] (state, data) {
      console.log('DOMAIN_UPDATE_SUCCESS')
      var callback = data.callback
      callback()
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/domain-edit.js